import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7d80817d")

_pushScopeId("data-v-7d80817d")
const _hoisted_1 = { class: "p-ml-1" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filterCardList, (filter, index) => {
    return _withDirectives((_openBlock(), _createBlock("div", {
      id: "filterCard",
      class: "p-d-flex p-flex-row",
      key: index
    }, [
      _createVNode("div", {
        id: 'filter-' + filter.name,
        ref: 'filter-' + filter.name,
        style: _ctx.panelDescriptor.style.filterCard,
        draggable: "true",
        onDragstart: ($event: any) => (_ctx.onDragStart($event, filter, 'filter-' + filter.name)),
        onDragend: ($event: any) => (_ctx.removeDragClass('filter-' + filter.name))
      }, [
        (filter.hierarchies.length > 1)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              icon: "fas fa-sitemap",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: ($event: any) => (_ctx.$emit('showMultiHierarchy', filter))
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true),
        _createVNode("span", _hoisted_1, _toDisplayString(filter.caption), 1),
        _withDirectives(_createVNode(_component_Button, {
          icon: "fas fa-filter",
          class: [{ 'olap-active-filter-icon': _ctx.filterIsActive(filter) }, "p-button-text p-button-rounded p-button-plain p-ml-auto"],
          onClick: ($event: any) => (_ctx.openFilterDialog(filter))
        }, null, 8, ["class", "onClick"]), [
          [_directive_tooltip, { value: _ctx.getSlicersTooltip(filter), disabled: !filter || !filter.hierarchies[0].slicers || filter.hierarchies[0].slicers.length === 0 }]
        ])
      ], 44, ["id", "onDragstart", "onDragend"])
    ], 512)), [
      [_directive_tooltip, { value: _ctx.$t('documentExecution.olap.filterPanel.activeLevels') + ': ' + _ctx.getNumberOfActiveLevels(filter), disabled: _ctx.getNumberOfActiveLevels(filter) === 0 }]
    ])
  }), 128))
})